import React from 'react';
import AnimatedSection from './AnimatedSection';
import './SharedStyles.css';
import './GamesShowcase.css';

const GamesShowcase = () => {
  const screens = [
    {
      id: 1,
      image: '/images/word-summer-chapter.jpg'
    },
    {
      id: 2,
      image: '/images/word-summer-streak.jpg'
    }
  ];

  return (
    <AnimatedSection direction="fade" className="games-section" delay={100} id="games">
      <div className="section-content-wrapper">
        <h2 className="section-title">
          Our <span className="title-accent">Games</span>
        </h2>
        <p className="section-subtitle">
          We develop high-quality mobile games that combine engaging gameplay with beautiful design.
        </p>
        
        <div className="game-showcase">
          <div className="game-info">
            <h3 className="game-title">Word Summer</h3>
            <p className="game-description">
              An engaging word puzzle game set in a beautiful garden environment. 
              Word Summer features seasonal themes, chapter-based progression, daily streak rewards, 
              and a fortune wheel system that keeps players engaged and coming back for more.
            </p>
          </div>
          
          <div className="game-screens">
            {screens.map((screen, index) => (
              <div 
                key={screen.id} 
                className="screen-card"
                style={{ '--delay': `${index * 150}ms` }}
              >
                <div className="phone-frame">
                  <div 
                    className="phone-screen"
                    style={{
                      backgroundImage: `url(${screen.image})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      backgroundColor: 'var(--phone-screen-bg)'
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default GamesShowcase;

